// extracted by mini-css-extract-plugin
export default {"card":"p_-z","carousel":"q_-z"};